var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199 83L165 160",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 83L115 110",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 110L61 114",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 156L31 120",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 170L84 156",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 183L119 170",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 114L31 120",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 62L199 83",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 160L152 183",
    stroke: "#FFD74E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 119,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 183,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 83,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 63,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 110,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 170,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 160,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 156,
    r: 4,
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 114,
    r: 4,
    fill: "#FFBF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.446bddfcc0beb689a02db934597bf918.svg";
export { ForwardRef as ReactComponent };